import React, { createContext, useState } from "react";

export const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [isBackNavigation, setIsBackNavigation] = useState(false);

  const handleNavigate = (path, isBack, navigate) => {
    setIsBackNavigation(isBack);
    navigate(path);
  };

  return (
    <NavigationContext.Provider value={{ isBackNavigation, setIsBackNavigation, handleNavigate }}>
      {children}
    </NavigationContext.Provider>
  );
};
